import React from 'react';
import { FormSection, TextField } from '../../../Components/Form';

// Min (suffix 1) and max (suffix 2) vessel limits, one column per measure.
const LIMITS = [
  { key: 'Draft', label: 'draft', unit: 'm' },
  { key: 'Loa', label: 'LOA', unit: 'm' },
  { key: 'Dwt', label: 'DWT', unit: 'MT' },
];

const DeliveryVesselSecondLocation = ({
  deliveryincotermformData,
  handleDeliveryNumberChangeIncoterm,
}) => {
  const renderLimit = (limit, index, labelPrefix) => {
    const name = `loc2${limit.key}${index}`;
    return (
      <TextField
        key={name}
        label={`${labelPrefix} ${limit.label}`}
        name={name}
        type='number'
        placeholder='Enter value'
        suffix={limit.unit}
        value={deliveryincotermformData[name] || ''}
        onChange={handleDeliveryNumberChangeIncoterm(name)}
      />
    );
  };

  return (
    <FormSection
      title={deliveryincotermformData.incotermLocation2Name || 'Second port'}
      description='Vessel size limits accepted at this port'
      columns={3}
    >
      {LIMITS.map(limit => renderLimit(limit, 1, 'Minimum'))}
      {LIMITS.map(limit => renderLimit(limit, 2, 'Maximum'))}
    </FormSection>
  );
};

export default DeliveryVesselSecondLocation;
